import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__position_9 } from '@shared/enums/ENUM__position_9';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__string_enum } from '../../_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__extend extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_IMAGE__EXTEND;

  /*
   *
   */

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE,
    },
  )
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__position_9.CENTER_CENTER, ENUM__position_9)
  image_align!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input(
    {
      value: 64,
      value_range: CONSTANTS_GENERATION__value_range.IMAGE_SIZE_IN,
      values_allowed: CONSTANTS_GENERATION__value_range.IMAGE_SIZE_IN,

      slider_step: 64,
      slider_step_values: [64, 128, 256, 512],
    },
    {},
  )
  shortest_side_extension!: FIELD_PRIMITIVE__int;

  /*
   *
   */
  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out__image!: FIELD__image_asset;

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.MASK })
  out__image_mask!: FIELD__image_asset;

  /*
   *
   */

  constructor() {
    super(ENUM__invocation_type.IMAGE__EXTEND);
  }
}
